import React from 'react';

const Page404 = () => (
  <div className="page-404">
    <h1>404</h1>
  </div>
);

export default Page404;
